import * as actionTypes from './actionTypes'
import { appLoading, appSuccess, appError } from './appActions'
import { confirmationRegisterIsApi } from '../../api/authApi'
import {toastr} from "react-redux-toastr";
import LocalStorageService from "../../services/LocalStorageService";
import {authSuccess} from "./authActions";
import { trackEvent } from "../../utils/trackEvent";
import { setDatadogUser } from "../../services/datadog";

export const confirmationRegisterIsSuccess = (data) => ({
  type: actionTypes.CONFIRMATION_REGISTER_IS_SUCCESS,
  payload: data,
})

export const confirmationRegisterIsFailed = (error) => ({
  type: actionTypes.CONFIRMATION_REGISTER_IS_FAILED,
  payload: error,
})

export const confirmationRegisterIsUser = (payload) => (dispatch) => {
  const { user, history } = payload;
  dispatch(appLoading());

  confirmationRegisterIsApi(user)
    .then((response) => {
      const { data } = response;

      if (!data || !data.user) {
        throw new Error('User data not found in response');
      }

      const userData = data.user;

      // Store user data in localStorage (including school info and offers)
      const localStorageService = LocalStorageService.getService();
      localStorageService.setUser(data);

      dispatch(appSuccess());
      dispatch(authSuccess({ data: data, token: null }));
      dispatch(confirmationRegisterIsSuccess(data));

      // Redirect after successful registration
      setTimeout(() => {
        history.push('/home');
      }, 0);

      toastr.success('INFO', 'Bienvenue chez StudCorp');

      // Track registration event
      try {
        trackEvent('registration_complete', {
          user_data: {
            email: userData.email || '',
            first_name: userData.name || '',
            last_name: userData.lastName || '',
          },
          user_roles: userData.roles || [],
        });
      } catch (trackError) {
        console.error('Error tracking registration:', trackError);
      }

      // Set Datadog user context for better error tracking
      try {
        setDatadogUser(userData);
      } catch (ddError) {
        console.error('Error setting Datadog user:', ddError);
      }
    })
    .catch((error) => {
      console.error('Registration error:', error);
      dispatch(confirmationRegisterIsFailed(error));
      dispatch(appError(error));

      const errorMessage = error?.response?.data?.message || error?.message || 'Une erreur est survenue lors de la connexion au serveur';
      toastr.error('Erreur', errorMessage);
    })
}